import {MatchDistrictRelationEvent} from './MatchDistrictRelationEvent';

/**
 * Fired if a match is linked to a district.
 */
export class MatchDistrictRelationCreated extends MatchDistrictRelationEvent {}
